import { t } from '../../i18n-t';
import type { FormConfig } from '../types';

export const getDocumentFileFormConfig = () => {
  return {
    Version: {
      fieldId: 'Version',
      formLabel: t('documentFiles.fields.Version'),
      columnHeader: t('documentFiles.columns.version'),
      allowAsConditionSource: true,
    },
    Status: {
      fieldId: 'Status',
      formLabel: t('documentFiles.fields.Status'),
      columnHeader: t('documentFiles.columns.status'),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'document_file_status' },
    },
    Summary: {
      fieldId: 'Summary',
      formLabel: t('documentFiles.fields.Summary'),
      columnHeader: t('documentFiles.columns.summary'),
      allowTargetConditions: true,
    },
    Type: {
      fieldId: 'Type',
      formLabel: t('documentFiles.fields.Type'),
      columnHeader: t('documentFiles.columns.type'),
      allowAsConditionSource: true,
      displayType: { displayType: 'rating', ratingKey: 'document_file_type' },
    },
    Content: {
      fieldId: 'Content',
      formLabel: t('documentFiles.fields.Text'),
      columnHeader: t('documentFiles.columns.content'),
    },
    Link: {
      fieldId: 'Link',
      formLabel: t('documentFiles.fields.Link'),
      columnHeader: t('documentFiles.columns.link'),
    },
    files: {
      fieldId: 'files',
      formLabel: t('documentFiles.fields.newFile'),
    },
    ReasonForReview: {
      fieldId: 'ReasonForReview',
      formLabel: t('documentFiles.fields.ReasonForReview'),
      columnHeader: t('documentFiles.columns.reviewReason'),
    },
    ReviewedBy: {
      fieldId: 'ReviewedBy',
      formLabel: t('documentFiles.fields.ReviewedBy'),
      columnHeader: t('documentFiles.columns.reviewedBy'),
      displayType: { displayType: 'users', multiple: false },
    },
    ReviewDate: {
      fieldId: 'ReviewDate',
      formLabel: t('documentFiles.fields.ReviewDate'),
      columnHeader: t('documentFiles.columns.reviewDate'),
      displayType: { displayType: 'date' },
    },
    NextReviewDate: {
      fieldId: 'NextReviewDate',
      formLabel: t('documentFiles.fields.NextReviewDate'),
      columnHeader: t('documentFiles.columns.reviewDue'),
      displayType: { displayType: 'date' },
    },
  } as const satisfies FormConfig;
};
